import styled from 'styled-components';
import { colors, toRgba } from '@/styles';

export const BranchSelector = styled.div`
  /* display: flex;
  flex-direction: column;
  position: relative; */
  .branch-selector-menu-list {
    padding: 0;
    & > * {
      border-bottom: 1px solid ${colors.secondary.lightGray3};
      &:first-child {
        border-radius: 4px 4px 0 0;
      }
      &:last-child {
        border-bottom: none;
        border-radius: 0 0 4px 4px;
      }
    }
  }
`;

export const SelectOption = styled.div`
  display: flex;
  /* flex-direction: column;  */
  gap: 5px;
  padding-right: 20px;
  /* align-items: center; */

  .commit-message {
    font-size: 0.8rem;
    margin: 5px -10px 0;
    padding: 5px 12px 0;
  }
`;

export const SingleValue = styled.div`
  margin-left: -7px;
  .icon {
    margin-right: 5px;
  }
  svg {
    flex-shrink: 0;
  }
  font-weight: 600;

  .commitRef {
    min-width: 0;
    /* font-family: var(--font-family-mono); */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CommitInfo = styled.div`
  display: flex;
  gap: 5px;
  font-size: 0.8rem;
  opacity: 0.5;
  /* color: ${colors.secondary.mediumGray}; */
  align-items: center;
`;
